import moment from 'moment';
import i18n from '../../../../i18n';
import { setDirection } from '../../../../helpers';
const i18nLanguageToMomentLocale = {
    en: 'en-US',
    he: 'he',
    ro: 'ro',
    uk: 'uk',
};
export const setMomentLocaleOnLanguageChange = (i18nLanguage) => {
    moment.locale(i18nLanguageToMomentLocale[i18nLanguage]);
};
export const applyEnvDefaultLanguage = (defaultLanguage) => {
    if (!defaultLanguage)
        return;
    // Don't apply the default language if the user has already chosen a language
    if (localStorage.getItem('currentLanguage'))
        return;
    if (i18n.language === defaultLanguage)
        return;
    setDirection(defaultLanguage === 'he' ? 'rtl' : 'ltr');
    i18n.changeLanguage(defaultLanguage);
};
